<template>
  <a-empty v-if="!$refs.description"  :description="description?description:$t('baseVO.empty')" class="ant-empty-normal">
    <img slot="image" src="@/assets/empty.svg" style="width: 62px;height: 40px;" />
  </a-empty>
  <a-empty v-else   class="ant-empty-normal">
    <img slot="image" src="@/assets/empty.svg" style="width: 62px;height: 40px;" />
    <span slot="description">
      <slot name="description"></slot>
    </span>
  </a-empty>
</template>

<script>
  export default {
    name: 'ptEmpty',
    props:{
      description:{
        type:String,
        default:null,
      }
    }
  }
</script>

<style scoped lang="less">
  .ant-empty-normal{
    display:flex;
    flex-direction: column;
    align-items: center;
  }
</style>